export default __webpack_public_path__ + "static/media/logo.d7df3bd8.png";